import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { useRootStore } from '../../App';
import { InputFile } from '../atoms';
import { Attachment } from '../molecules/Attachment';

const StyledDiv = styled.div`
  float: left;
  ${(props: { isWide: boolean }) =>
    props.isWide
      ? `background: #ffffff;
      overflow: hidden;
      position: relative;
      height: 48px;
      display: flex;
      align-items: center;
      padding-right: 5px;`
      : `padding-left: 3%;
      padding-right: 3%;`}
`;

const StyledP = styled.p`
  color: ${(props: { disabled: boolean }) =>
    props.disabled ? '#cccccc !important' : '#828282'};
  cursor: ${(props: { disabled: boolean }) =>
    props.disabled ? 'default' : 'pointer'};
`;

const ImgStyledSpan = styled.span`
  position: absolute;
`;

const StyledImg = styled.img`
  width: ${(props: { isWide: boolean }) => (props.isWide ? 16 : 23)}px;
  height: ${(props: { isWide: boolean }) => (props.isWide ? 16 : 23)}px;
  ${(props: { isWide: boolean }) =>
    props.isWide ? 'padding: 4px;' : 'cursor: pointer;'}
`;

const LabelStyledSpan = styled.span`
  font-size: 14px;
  line-height: 18px;
  margin-left: 18px;
`;

const StyledSpan = styled.span`
  margin-left: 4px;
`;

interface Props {
  disabled: boolean;
  isWide: boolean;
  onClick: Function;
}

export const FileUploadButton = observer((props: Props) => {
  const root = useRootStore();
  const {
    attachments,
    canUpload,
    fileUploadDocumentRequest,
    onDeleteAttachFile,
  } = root.chatInputStore;
  const { isWide } = root.layoutStore;
  // Component method
  const onFileSelector = () => {
    const input: HTMLInputElement | null =
      document.querySelector('#file-upload');
    if (input) {
      input.click();
    }
  };
  const submitDisable = props.disabled || !canUpload;

  return isWide ? (
    <>
      <StyledDiv isWide={isWide}>
        <StyledP disabled={submitDisable} onClick={onFileSelector}>
          <InputFile
            id="file-upload"
            multiple={false}
            uploadDocumentRequest={fileUploadDocumentRequest}
            disabled={submitDisable}
          />
          <ImgStyledSpan>
            <StyledImg
              isWide={isWide}
              src={
                submitDisable
                  ? '/images/attachment_gray.png'
                  : '/images/attachment.png'
              }
              alt=""
            />
          </ImgStyledSpan>
          <LabelStyledSpan>
            <StyledSpan className="_uploadLabel">
              画像をアップロードする
            </StyledSpan>
          </LabelStyledSpan>
        </StyledP>
      </StyledDiv>
      <section>
        {attachments.map((attachment, index) => {
          return (
            <Attachment
              key={`attachments-${index}`}
              attachment={attachment}
              isWide={isWide}
              onClick={onDeleteAttachFile}
            />
          );
        })}
      </section>
    </>
  ) : (
    <StyledDiv isWide={isWide}>
      <label>
        <StyledImg
          isWide={isWide}
          src={
            submitDisable
              ? '/images/attachment_gray.png'
              : '/images/attachment.png'
          }
          onClick={onFileSelector}
        />
      </label>
      <InputFile
        id="file-upload"
        multiple={false}
        uploadDocumentRequest={fileUploadDocumentRequest}
        disabled={submitDisable}
      />
    </StyledDiv>
  );
});
